import React from 'react'
import Dashboard from '../../../../dashboard'
import ReportDetailsView from './page'

const ReportDetails = () => {
  return <Dashboard component={<ReportDetailsView />} />
}

export default ReportDetails
